export default "__VITE_ASSET__bee5ccdb__"